import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getRoleModuleMappingDetailByRoleApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}role-module-mapping/get-data-by-role`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default getRoleModuleMappingDetailByRoleApi